// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import React from "react";

import BAILoadingIndicator from "./BAILoadingIndicator";
import Flex, { type FlexProps } from "./Flex";

interface FlexActivityIndicatorProps extends FlexProps {
  /** Forwarded to BAILoadingIndicator; use a larger size for full-screen loaders. */
  size?: number;
}

const FlexActivityIndicator: React.FC<FlexActivityIndicatorProps> = ({
  style,
  children,
  size,
  ...flexProps
}) => {
  return (
    <Flex
      direction="row"
      justify="center"
      align="center"
      style={{ width: "100%", height: "100%", ...style }}
      {...flexProps}
    >
      <BAILoadingIndicator size={size} />
      {children}
    </Flex>
  );
};

export default FlexActivityIndicator;
